module.exports = __webpack_public_path__ + "img/bg.5ca0975f.jpg";